import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation
} from '@angular/core';
import { map, startWith } from 'rxjs/operators';

import * as uuid from 'uuid';
import { NgForm, NgModel } from '@angular/forms';
import { Observable } from 'rxjs';
import { UtilityService } from '../../services/utility/utility.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'sd-autocomplete-control',
  templateUrl: './autocomplete-control.component.html',
  styleUrls: [
    '../../assets/css/form.scss',
  ],
  encapsulation: ViewEncapsulation.None
})

export class AutocompleteControlComponent implements OnInit, OnDestroy, AfterViewInit {
  private initialized = false;
  private pModel: any;
  private pItems: any[] | ((searchText: string) => Promise<any[]>) = [];
  private flag = false;
  private previous: Date;
  private previousResults: any[] = [];
  private delay = 500; // Sau khoảng thời gian delay nếu không có thay đổi thì thì mới bắt đầu thực hiện gọi hàm
  private isServerFilter = false;
  name = uuid.v4();
  loading = false;
  @Input() form: NgForm;
  @Input() label: string;
  @Input() valueField: string;
  @Input() displayField: string;

  private cItems: any[] = [];
  @Input() set items(items: any[] | ((searchText?: string) => Promise<any[]>)) {
    this.pItems = items || [];
    this.isServerFilter = !Array.isArray(this.pItems);
    if (this.initialized) {
      this.onChanges().then(() => this.formModel?.control.setValue(this.formModel?.control.value));
    }
  }

  @Input() limit = 100;

  filteredItems: Observable<any[]>;

  cModel: any;
  @Input() set model(value: any) {
    this.pModel = value;
    if (this.initialized) {
      this.onChanges(value).then(() => this.formModel?.control.setValue(value));
    }
  }
  @Output() modelChange = new EventEmitter();
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter();
  @Output() sdChange = new EventEmitter();

  // Optional
  @Input() required: boolean;
  @Input() disabled: boolean;

  @ViewChild('formModel', { static: true }) formModel: NgModel;
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) autocompleteTrigger: MatAutocompleteTrigger;

  constructor(
    private ref: ChangeDetectorRef,
    private utilityService: UtilityService) {
  }

  ngOnInit() {
    this.filteredItems = this.formModel.valueChanges.pipe(
      startWith<string | { [key: string]: string }>(''),
      map(item => typeof item === 'string' ? item : (item ? item[this.displayField] : '')),
      map(this.filter)
    );
  }

  ngAfterViewInit() {
    this.form?.addControl(this.formModel);
    this.onChanges(this.pModel).then(() => this.formModel?.control.setValue(this.pModel));
    this.initialized = true;
    this.ref.detectChanges();
  }

  ngOnDestroy() {
    this.form?.removeControl(this.formModel);
  }

  private onChanges = async (searchText?: string) => {
    this.cModel = this.pModel;
    let items = [];
    if (typeof (this.pItems) === 'function') {
      items = await this.loadItems(searchText, this.pItems);
    } else {
      items = this.pItems;
    }
    if (this.flag || (!this.valueField && !this.displayField)) {
      this.cItems = items.map(e => ({
        code: e
      }));
      this.flag = true;
      this.valueField = 'code';
      this.displayField = 'code';
    } else {
      this.cItems = items;
    }
    this.formModel?.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    this.ref.detectChanges();
  }

  private loadItems = async (searchText: string, items: (searchText?: string) => Promise<any[]>) => {
    this.previous = new Date();
    await new Promise(resolve => setTimeout(resolve, this.delay));
    const now = new Date();
    const dif = now.getTime() - this.previous.getTime();
    if (dif < this.delay) {
      return this.previousResults;
    }
    this.loading = true;
    this.previousResults = await items(searchText).finally(() => this.loading = false);
    return this.previousResults;
  }

  onChange = (item: any) => {
    if (typeof item !== 'string') {
      this.cModel = item ? item[this.valueField] : undefined;
      this.modelChange.emit(this.cModel);
      this.change.emit(item);
      this.sdChange.emit(item);
    } else {
      if (!item) {
        this.clear();
      }
      this.onChanges(item);
    }
  }

  filter = (value: string): { [key: string]: string }[] => {
    const items = this.cItems;
    if (!this.name || this.isServerFilter) {
      return this.cItems.filter((item, index) => index < this.limit);
    }

    let cItemsDisplayField = [];
    let cItemsValueField = [];

    cItemsDisplayField = this.cItems.filter(item => {
      return this.utilityService.changeAliasLowerCase(item[this.displayField])
        .indexOf(this.utilityService.changeAliasLowerCase(value)) !== -1;
    }).filter((item, index) => index < this.limit);

    cItemsValueField = this.cItems.filter(item => {
      return this.utilityService.changeAliasLowerCase(item[this.valueField])
        .indexOf(this.utilityService.changeAliasLowerCase(value)) !== -1;
    }).filter((item, index) => index < this.limit);

    this.cItems = [...cItemsDisplayField, ...cItemsValueField];
    const uniqueItems = [];
    const distinctItems = [];
    for (const cItem of this.cItems) {
      if ( !uniqueItems[cItem[this.valueField]]) {
        distinctItems.push(cItem);
        uniqueItems[cItem[this.valueField]] = 1;
      }
    }
    return distinctItems;
  }

  displayFn = (value: string | { [key: string]: string }): string | undefined => {
    if (typeof value === 'string') {
      if (!this.cItems) {
        return value;
      }
      const selectedItem = this.cItems.find(item => item[this.valueField] === value);
      if (selectedItem) {
        return selectedItem[this.displayField];
      }
      return value;
    } else {
      return value ? value[this.displayField] : undefined;
    }
  }

  clear = ($event?: any) => {
    $event?.stopPropagation();
    this.cModel = undefined;
    this.modelChange.emit(this.cModel);
    this.change.emit(this.cModel);
    this.sdChange.emit(this.cModel);
    this.formModel.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    if ($event) {
      this.autocompleteTrigger._onChange('');
      this.autocompleteTrigger?.openPanel();
    }
  }

  reValidate = () => {
    this.formModel?.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }
}
